// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.error_exam_block {
  position: relative;
}
.error_exam_block .question_area .q_Name {
  position: relative;
  padding-left: 30px;
  font: 400 15px/25px "proxima-nova", sans-serif;
}
.error_exam_block .question_area .q_Name .q_No {
  font: 600 16px/25px "proxima-nova", sans-serif;
  position: absolute;
  left: 0;
  color: #00C596;
}
.error_exam_block .question_area img {
  margin: 0 6px;
  max-width: 450px;
}
.error_exam_block .q_options {
  position: relative;
}
.error_exam_block .q_options .single_card {
  position: relative;
  cursor: pointer;
}
.error_exam_block .q_options .single_card.active {
  box-shadow: 0px 3px 20px hsla(0, 0%, 0%, 0.051);
  border: 1px solid rgba(0, 197, 150, 0.2392156863);
}
.error_exam_block .q_options .single_card.active .option_name .option_No {
  background: #C2F1E6;
}
.error_exam_block .q_options .single_card.active .option_selected {
  position: relative;
}
.error_exam_block .q_options .single_card.active .option_selected i {
  color: #00c596;
  font-size: 16px;
  position: relative;
}
.error_exam_block .q_options .single_card.active .option_selected i::after {
  color: #00c596;
  content: "\\f00c";
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  background-image: none;
  border-radius: 0.46rem;
  text-align: center;
  line-height: 16px;
  font-size: 8px;
  position: absolute;
  left: 4px;
  top: 0;
}
.error_exam_block .q_options .single_card .option_name {
  position: relative;
  padding-left: 30px;
}
.error_exam_block .q_options .single_card .option_name .option_No {
  position: absolute;
  left: 0;
  width: 20px;
  height: 20px;
  line-height: 20px;
  text-align: center;
  border-radius: 4px;
  color: #707070;
  background: #EEEEEE;
}
.error_exam_block .q_options .single_card .option_selected {
  position: relative;
}
.error_exam_block .q_options .single_card .option_selected i {
  font-size: 16px;
}
.error_exam_block .q_options .single_card.incorrect {
  box-shadow: 0px 3px 20px hsla(0, 0%, 0%, 0.051);
  border: 1px solid hsla(14, 100%, 50%, 0.239);
}
.error_exam_block .q_options .single_card.incorrect .option_name .option_No {
  background: #F1C2C2;
}
.error_exam_block .q_options .single_card.incorrect .option_selected {
  position: relative;
}
.error_exam_block .q_options .single_card.incorrect .option_selected i {
  color: #c52e00;
  font-size: 16px;
  position: relative;
}
.error_exam_block .q_options .single_card.incorrect .option_selected i::after {
  color: #c52e00;
  content: "\\f00c";
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  background-image: none;
  border-radius: 0.46rem;
  text-align: center;
  line-height: 16px;
  font-size: 8px;
  position: absolute;
  left: 4px;
  top: 0;
}
.error_exam_block .instruction button {
  font-size: 13px;
  border-radius: 25px;
}
.error_exam_block .instruction .helpTags li i {
  cursor: pointer;
}

.wrapper .error_exam_block .fixed-bottom {
  width: 100%;
  z-index: 2;
}
@media screen and (min-width: 1200px) {
  .wrapper .error_exam_block .fixed-bottom {
    margin-left: 150px;
  }
}
.wrapper.sidebar-enable .error_exam_block .fixed-bottom {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/student_module/components/learn_practice/start_error_exam/start_error_page/_errorexam.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;AACJ;AAEQ;EACI,kBAAA;EACA,kBAAA;EACA,8CAAA;AAAZ;AAEY;EACI,8CAAA;EACA,kBAAA;EACA,OAAA;EACA,cAAA;AAAhB;AAGQ;EACI,aAAA;EACA,gBAAA;AADZ;AAKI;EACI,kBAAA;AAHR;AAKQ;EACI,kBAAA;EACA,eAAA;AAHZ;AAKY;EACI,+CAAA;EACA,iDAAA;AAHhB;AAKgB;EACI,mBAAA;AAHpB;AAMgB;EACI,kBAAA;AAJpB;AAMoB;EACI,cAAA;EACA,eAAA;EACA,kBAAA;AAJxB;AAMwB;EACI,cAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;AAJ5B;AAYY;EACI,kBAAA;EACA,kBAAA;AAVhB;AAYgB;EACI,kBAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;AAVpB;AAcY;EACI,kBAAA;AAZhB;AAcgB;EACI,eAAA;AAZpB;AAgBY;EACI,+CAAA;EACA,4CAAA;AAdhB;AAgBgB;EACI,mBAAA;AAdpB;AAiBgB;EACI,kBAAA;AAfpB;AAiBoB;EACI,cAAA;EACA,eAAA;EACA,kBAAA;AAfxB;AAiBwB;EACI,cAAA;EACA,gBAAA;EACA,iCAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,MAAA;AAf5B;AAyBQ;EACI,eAAA;EACA,mBAAA;AAvBZ;AA0BQ;EACI,eAAA;AAxBZ;;AA6BI;EACI,WAAA;EACA,UAAA;AA1BR;AA2BQ;EAHJ;IAIY,kBAAA;EAxBd;AACF;AA2BQ;EACI,WAAA;AAzBZ","sourcesContent":[".error_exam_block {\n    position: relative;\n\n    .question_area {\n        .q_Name {\n            position: relative;\n            padding-left: 30px;\n            font: 400 15px/25px 'proxima-nova', sans-serif;\n    \n            .q_No {\n                font: 600 16px/25px 'proxima-nova', sans-serif;\n                position: absolute;\n                left: 0;\n                color: #00C596;\n            }\n        }\n        img {\n            margin: 0 6px;\n            max-width: 450px;\n        }\n    }\n\n    .q_options {\n        position: relative;\n\n        .single_card {\n            position: relative;\n            cursor: pointer;\n\n            &.active {\n                box-shadow: 0px 3px 20px hsla(0, 0%, 0%, 0.051);\n                border: 1px solid #00C5963D;\n\n                .option_name .option_No {\n                    background: #C2F1E6;\n                }\n\n                .option_selected {\n                    position: relative;\n\n                    i {\n                        color: #00c596;\n                        font-size: 16px;\n                        position: relative;\n\n                        &::after {\n                            color: #00c596;\n                            content: \"\\f00c\";\n                            font-family: \"Font Awesome 5 Pro\";\n                            font-weight: 900;\n                            background-image: none;\n                            border-radius: 0.46rem;\n                            text-align: center;\n                            line-height: 16px;\n                            font-size: 8px;\n                            position: absolute;\n                            left: 4px;\n                            top: 0;\n                        }\n\n                    }\n                }\n            }\n\n\n            .option_name {\n                position: relative;\n                padding-left: 30px;\n\n                .option_No {\n                    position: absolute;\n                    left: 0;\n                    width: 20px;\n                    height: 20px;\n                    line-height: 20px;\n                    text-align: center;\n                    border-radius: 4px;\n                    color: #707070;\n                    background: #EEEEEE;\n                }\n            }\n\n            .option_selected {\n                position: relative;\n\n                i {\n                    font-size: 16px;\n                }\n            }\n\n            &.incorrect {\n                box-shadow: 0px 3px 20px hsla(0, 0%, 0%, 0.051);\n                border: 1px solid hsla(14, 100%, 50%, 0.239);\n\n                .option_name .option_No {\n                    background: #F1C2C2;\n                }\n\n                .option_selected {\n                    position: relative;\n\n                    i {\n                        color: #c52e00;\n                        font-size: 16px;\n                        position: relative;\n\n                        &::after {\n                            color: #c52e00;\n                            content: \"\\f00c\";\n                            font-family: \"Font Awesome 5 Pro\";\n                            font-weight: 900;\n                            background-image: none;\n                            border-radius: 0.46rem;\n                            text-align: center;\n                            line-height: 16px;\n                            font-size: 8px;\n                            position: absolute;\n                            left: 4px;\n                            top: 0;\n                        }\n\n                    }\n                }\n            }\n        }\n    }\n\n    .instruction {\n        button {\n            font-size: 13px;\n            border-radius: 25px;\n        }\n\n        .helpTags li i {\n            cursor: pointer;\n        }\n    }\n}\n.wrapper{\n    .error_exam_block .fixed-bottom {\n        width: 100%;\n        z-index: 2;\n        @media screen and (min-width: 1200px) {\n                margin-left: 150px;\n            }\n        }\n    &.sidebar-enable {\n        .error_exam_block .fixed-bottom {\n            width: 100%;  \n            // margin-left: 0;\n          }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
